import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import i18n from '../../i18n';
import { bindActionCreators } from 'redux';
import { fetchProductsMe } from '../../actions/products';
import { withCurrency } from '../currency';
import { CurrencyFormatter } from '../../utils/Intl';
import { Flex, Link, Text } from '@homeexchange/design';
import { fetchingStatuses } from '../../reducers/loading';
function BecomeMemberSection(props) {
    var currency = props.currency, user = props.user, accessToken = props.accessToken, products = props.products, userFetchingStatus = props.userFetchingStatus, fetchProductsMe = props.fetchProductsMe;
    var _a = useState(), subProduct = _a[0], setSubProduct = _a[1];
    var isUserFetchedOrNotLoggedIn = !accessToken || userFetchingStatus === fetchingStatuses.FINISHED;
    useEffect(function () {
        if (isUserFetchedOrNotLoggedIn) {
            fetchProductsMe(currency);
        }
    }, [isUserFetchedOrNotLoggedIn, currency]);
    useEffect(function () {
        if (isUserFetchedOrNotLoggedIn) {
            setSubProduct(products.find(function (product) { return product.isSubscription(); }));
        }
    }, [products, isUserFetchedOrNotLoggedIn]);
    if ((accessToken && userFetchingStatus !== fetchingStatuses.FINISHED) || !subProduct) {
        return null;
    }
    return (React.createElement("article", { className: "pack-required" },
        React.createElement(Flex, { gap: "2" },
            React.createElement(Text, { size: "xl", isBold: true }, i18n.t('home:page.homeview.becomeMember.title')),
            React.createElement(Text, null, i18n.t('home:page.homeview.becomeMember.desc', {
                amount: CurrencyFormatter.format(subProduct.get('original_price'), currency)
            })),
            React.createElement(Link, { href: !user ? i18n.t('url:subscription-he-cms') : i18n.t('url:my-plan.url'), color: "secondary" }, i18n.t('common:learn_more')))));
}
var mapStateToProps = function (state) { return ({
    user: state.user,
    accessToken: state.auth.accessToken,
    userFetchingStatus: state.loading.userFetchingStatus,
    products: state.products
}); };
var mapDispatchToProps = function (dispatch) { return ({
    fetchProductsMe: bindActionCreators(fetchProductsMe, dispatch)
}); };
export default compose(connect(mapStateToProps, mapDispatchToProps), withCurrency)(BecomeMemberSection);
